

























































































































































































































































































































































import Vue from "vue";
import vIcon from "@/components/v-components/v-icon.vue";
import moment from "moment-timezone";
import { mapGetters, mapActions } from "vuex";
import { Localize } from "@/plugins/localization";
import Controls from "@/components/vue-components/Controls.vue";
import router from "@/router";
import VSelect from "@/components/v-components/v-select.vue";
import { TranslateResult } from "vue-i18n";
import VelloIcon from "@/components/vue-components/VelloIcon.vue";

export default Vue.extend({
  name: "Register",
  components: {
    vIcon,
    VSelect,
    Controls,
    VelloIcon
  },
  data: () => {
    return {
      email: "" as string,
      password: "" as string,
      firstName: "" as string,
      lastName: "" as string,
      phone: "" as string,
      companyName: "" as string,
      velloUrl: "" as string,
      timezone: moment.tz.guess() as string,
      language: Localize.getSupportedLanguagesList().find(
        obj =>
          obj.key ===
          ((router.currentRoute.params.locale ||
            Localize.getUserLocale().localeNoIso) as string)
      ) || { key: "en", label: "English" },
      timeZoneOptions: Localize.getSupportedTimeZonesList(),
      languageOptions: Localize.getSupportedLanguagesList(),
      acceptedTerms: false as boolean,
      status: "base" as string,
      errors: {
        email_missing: false,
        email_exists: false,
        email_notValid: false,
        email_tooLong: false,
        password_missing: false,
        password_tooShort: false,
        password_tooLong: false,
        firstName_missing: false,
        firstName_tooLong: false,
        lastName_missing: false,
        lastName_tooLong: false,
        phone_missing: false,
        phone_notValid: false,
        phone_tooLong: false,
        companyName_missing: false,
        companyName_tooLong: false,
        velloUrl_missing: false,
        velloUrl_notValid: false,
        velloUrl_tooLong: false,
        tos_notAccepted: false
      } as { [key: string]: boolean },
      locale: router.currentRoute.params.locale as string,
      baseUrl: process.env.VUE_APP_VELLO_URL as string
    };
  },
  computed: {
    ...mapGetters([
      "GET_CSRF_INFORMATION",
      "GET_REGISTER_VALIDATION_STATUS",
      "GET_REGISTER_STATUS",
      "GET_USER_STATUS",
      "COMPANY_GET_WIZARD"
    ])
  },
  watch: {
    velloUrl: {
      handler: function(value) {
        this.errors.velloUrl_notValid = !this.testString("url", value);
      },
      immediate: true
    }
  },
  created() {
    const userState = this.GET_USER_STATUS.status;
    if (userState) this._Temp_handleAllreadLoggedIn();
  },
  methods: {
    ...mapActions([
      "USER_VALIDATE_SIGNUP",
      "USER_REGISTER",
      "USER_LOGIN",
      "COMPANY_PREPARE_WIZARD",
      "UPDATE_NOTIFICATION_STATUS"
    ]),

    getPlaceholder(type: string): TranslateResult | undefined {
      switch (type) {
        case "timezone":
          return this.$i18n.t(
            "register.form.select-timezone-search-placeholder"
          );
        case "language":
          return this.$i18n.t(
            "register.form.select-language-search-placeholder"
          );
        default:
          break;
      }
    },

    handleCancelRegister(): void {
      window.location.replace(
        `${process.env.VUE_APP_VELLO_URL}/${this.language.key}`
      );
    },

    handleClickLogin(): void {
      this.$router.push({ name: "Login" });
    },

    handleFormSubmit(): void {
      if (this.preValidateFormData()) {
        this.status = "loading";
        this.$store
          .dispatch("USER_VALIDATE_SIGNUP", {
            data: this.getFormData("validate"),
            token: this.GET_CSRF_INFORMATION.token
          })
          .then(() => {
            if (
              this.GET_REGISTER_VALIDATION_STATUS.response.email_already_exists
            ) {
              this.errors.email_exists = true;
              throw new Error("emailAlreadyExists");
            }
            return this.$store.dispatch("USER_REGISTER", {
              data: this.getFormData("register"),
              token: this.GET_CSRF_INFORMATION.token
            });
          })
          .then(() => {
            if (this.GET_REGISTER_STATUS.email === "") {
              this.$store.dispatch("UPDATE_NOTIFICATION_STATUS", {
                status: true,
                component: "error"
              });
              throw new Error("account creation error");
            }
            return this.tryLoginRecursively();
          })
          .then(() => {
            return this.$store.dispatch("COMPANY_PREPARE_WIZARD", {
              data: this.getFormData("wizard"),
              token: this.GET_CSRF_INFORMATION.token
            });
          })
          .then(() => {
            this.status = "done";
            this.$gtag.event("sign_up", {
              event_category: "engagement",
              event_label: "method"
            });
            this.$gtag.event("conversion", {
              send_to: "AW-940295887/PrP8CNLyi-4CEM-Nr8AD"
            });
            setTimeout(() => {
              window.location.replace(
                `${process.env.VUE_APP_VELLO_URL}/${this.COMPANY_GET_WIZARD.companyUrl}`
              );
            }, 500);
          })
          .catch(() => {
            this.status = "base";
            if (this.GET_REGISTER_VALIDATION_STATUS.connectionError) {
              this.$store.dispatch("UPDATE_NOTIFICATION_STATUS", {
                status: true,
                component: "error"
              });
              throw new Error("validation-connectionError");
            }
            if (
              this.GET_REGISTER_STATUS.connectionError ||
              this.GET_REGISTER_STATUS.error
            ) {
              this.$store.dispatch("UPDATE_NOTIFICATION_STATUS", {
                status: true,
                component: "error"
              });
              throw new Error("register-connectionError");
            }
            if (this.GET_USER_STATUS.connectionError) {
              this.$store.dispatch("UPDATE_NOTIFICATION_STATUS", {
                status: true,
                component: "error"
              });
              throw new Error("user-connectionError");
            }
            if (this.COMPANY_GET_WIZARD.didInvalidate) {
              this.$store.dispatch("UPDATE_NOTIFICATION_STATUS", {
                status: true,
                component: "error"
              });
              throw new Error("wizardInitError");
            }
          });
      }
    },

    tryLoginRecursively(): Promise<unknown> {
      const delayBetweenReg = 3000 as number;
      const maxTries = 3 as number;
      let tries = 0 as number;
      return new Promise((resolve, reject) => {
        const login = () => {
          this.$store
            .dispatch("USER_LOGIN", {
              credentials: this.getFormData("login"),
              token: this.GET_CSRF_INFORMATION.token
            })
            .finally(() => {
              if (typeof this.GET_USER_STATUS.user.id !== "undefined") {
                return resolve(true);
              }

              if (
                typeof this.GET_USER_STATUS.user.id === "undefined" &&
                tries === maxTries
              ) {
                return reject("server error");
              }
              setTimeout(() => {
                tries += 1;
                login();
              }, delayBetweenReg);
            });
        };
        login();
      });
    },

    preValidateFormData(): boolean {
      const minLength = 12 as number;
      const maxLength = 120 as number;
      // Reset errors
      Object.keys(this.errors).forEach(key => (this.errors[key] = false));

      // Email section
      this.errors.email_missing = !this.email;
      this.errors.email_notValid = !this.testString("email", this.email);
      this.errors.email_tooLong = this.email.length > maxLength;

      // Password section
      this.errors.password_missing = !this.password;
      this.errors.password_tooShort = this.password.length < minLength;
      this.errors.password_tooLong = this.password.length > maxLength;

      // Contact information
      this.errors.firstName_missing = !this.firstName;
      this.errors.firstName_tooLong = this.firstName.length > maxLength;
      this.errors.lastName_missing = !this.lastName;
      this.errors.lastName_tooLong = this.lastName.length > maxLength;
      this.errors.phone_missing = !this.phone;
      this.errors.phone_notValid = !this.testString("phone", this.phone);
      this.errors.phone_tooLong = this.phone.length > maxLength;

      // Company information
      this.errors.companyName_missing = !this.companyName;
      this.errors.companyName_tooLong = this.companyName.length > maxLength;
      this.errors.velloUrl_missing = !this.velloUrl;
      this.errors.velloUrl_notValid = !this.testString("url", this.velloUrl);
      this.errors.velloUrl_tooLong = this.velloUrl.length > maxLength;

      // Terms of service
      this.errors.tos_notAccepted = !this.acceptedTerms;

      setTimeout(
        () =>
          Object.keys(this.errors).forEach(key => (this.errors[key] = false)),
        10000
      );
      return Object.keys(this.errors).every(key => !this.errors[key]);
    },

    handlePrepareVelloUrl(): void {
      const urlSuggestion = encodeURIComponent(
        this.companyName
          .normalize("NFD")
          .replace(/[^a-zA-Z0-9/ /_-]|[\u0300-\u036f]/gi, "")
          .replace(/ /g, "-")
          .replace(/\//g, "")
          .toLowerCase()
      );
      this.testString("url", urlSuggestion) && (this.velloUrl = urlSuggestion);
    },

    testString(type: string, string: string): boolean {
      const validEmailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const urlSafeRegex = /^[a-zA-Z0-9_-]*$/;
      const validPhone = /^[0-9+() -]{1,100}$/;
      switch (type) {
        case "email":
          return validEmailRegex.test(string);
        case "url":
          return urlSafeRegex.test(string);
        case "phone":
          return validPhone.test(string);
        default:
          return false;
      }
    },

    getFormData(type: string): object {
      let formData = {};
      switch (type) {
        case "validate":
          return (formData = {
            company: this.companyName.trim(),
            email: this.email.trim(),
            first_name: this.firstName.trim(),
            language: this.language.key,
            last_name: this.lastName.trim(),
            office: this.companyName.trim(),
            password: this.password.trim(),
            phone: this.phone.trim().replace(/[^0-9+]/g, ""),
            timezone: this.timezone,
            vello_url: this.velloUrl.trim(),
            voucher: ""
          });
        case "register":
          return (formData = {
            email: this.email.trim(),
            first_name: this.firstName.trim(),
            language: this.language.key,
            last_name: this.lastName.trim(),
            name: `${this.firstName} ${this.lastName}`,
            password: this.password.trim(),
            phone: this.phone.trim().replace(/[^0-9+]/g, ""),
            timezone: this.timezone
          });
        case "login":
          return (formData = {
            email: this.email.trim(),
            password: this.password.trim()
          });
        case "wizard":
          return (formData = {
            company: {
              name: this.companyName.trim(),
              settings: {},
              url: this.velloUrl.trim()
            },
            office: {
              name: this.companyName.trim()
            },
            language: this.language.key,
            timezone: this.timezone
          });
        default:
          return formData;
      }
    },

    _Temp_handleAllreadLoggedIn(): void {
      this.$store
        .dispatch("USER_LOGOUT", this.GET_CSRF_INFORMATION.token)
        .then(() => {
          return this.$store.dispatch("FETCH_CSRF_INFORMATION");
        })
        .catch(error => {
          console.error(error);
          this.$store.dispatch("UPDATE_NOTIFICATION_STATUS", {
            status: true,
            component: "error"
          });
        });
    }
  }
});
